import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { UnstyledButton } from "@mantine/core";
import { addDays, addWeeks, addMonths, addYears } from "date-fns";
import { bumpDate } from "./bump-date";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Pill-shaped shortcut buttons that bump the due date by +3d, +1w, +1m, or +1y. */
export function DueDateShortcuts(_ref) {
  var currentDate = _ref.currentDate,
    onBump = _ref.onBump;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var pillClass = "rounded-sds-full border border-sds-brand-default bg-sds-brand-tertiary px-3 py-1.5 text-style-label-emphasis text-sds-brand-default transition-colors hover:bg-sds-brand-default hover:text-sds-brand-on-brand";
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-2 pt-1"
  }, /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "task-detail-shortcut-3d",
    className: pillClass,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_SHORTCUT_3D);
      onBump(bumpDate(currentDate, function (d) {
        return addDays(d, 3);
      }));
    }
  }, t("label.due_shortcut_3d", "+ 3d")), /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "task-detail-shortcut-1w",
    className: pillClass,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_SHORTCUT_1W);
      onBump(bumpDate(currentDate, function (d) {
        return addWeeks(d, 1);
      }));
    }
  }, t("label.due_shortcut_1w", "+ 1w")), /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "task-detail-shortcut-1m",
    className: pillClass,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_SHORTCUT_1M);
      onBump(bumpDate(currentDate, function (d) {
        return addMonths(d, 1);
      }));
    }
  }, t("label.due_shortcut_1m", "+ 1m")), /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "task-detail-shortcut-1y",
    className: pillClass,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_SHORTCUT_1Y);
      onBump(bumpDate(currentDate, function (d) {
        return addYears(d, 1);
      }));
    }
  }, t("label.due_shortcut_1y", "+ 1y")));
}